import { FrontChartInterval } from "../enums/frontChartInterval";
import { BaseFilterModel } from "./baseFilter.model";

export class MediaPlatformFilter extends BaseFilterModel{
    trackId: number;
    chartInterval : FrontChartInterval = FrontChartInterval.alltime;
  }